import { render, staticRenderFns } from "./Flag.component.html?vue&type=template&id=75585e1c&scoped=true&"
import script from "./Flag.vue?vue&type=script&lang=ts&"
export * from "./Flag.vue?vue&type=script&lang=ts&"
import style0 from "./Flag.component.scss?vue&type=style&index=0&id=75585e1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75585e1c",
  null
  
)

export default component.exports